import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";

/** Hook that returns public config (whatsapp, email, address, maps) fetched from backend. */
export function useConfig() {
  const [cfg, setCfg] = useState({
    whatsapp_url: "",
    contact_email: "",
    endereco: "",
    telefone: "",
    maps: { embed_url: "", directions_url: "", query: "" },
  });
  useEffect(() => {
    endpoints
      .config()
      .then((data) =>
        setCfg((c) => ({ ...c, ...data, maps: { ...c.maps, ...(data.maps || {}) } }))
      )
      .catch(() => {});
  }, []);
  return cfg;
}
